import { Component, inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { TableModule } from 'primeng/table';
import { TabsModule } from 'primeng/tabs';
import { DialogService } from 'primeng/dynamicdialog';
import { Router } from '@angular/router';
import { CadastrarVagasComponent } from '../../vagas/cadastrar-vagas/cadastrar-vagas.component';
import { ListaProfissionaisComponent } from "../lista-profissionais/lista-profissionais.component";
import { ApiService } from '@core/providers/http';
import { ProfissionalService } from '../../../services';
import { BackButtonComponent } from '@app/shared/components/back-button/back-button.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-home-profissionais',
  imports: [
    TableModule, TabsModule,
    InputTextModule, FormsModule, ButtonModule,
    ListaProfissionaisComponent,
    BackButtonComponent,
    CommonModule,
],
  providers: [DialogService, ProfissionalService, ApiService],
  templateUrl: './home-profissionais.component.html',
  styleUrl: './home-profissionais.component.scss'
})
export class HomeProfissionaisComponent implements OnInit{

  router = inject(Router)
  dialogService = inject(DialogService);
  profissionalService = inject(ProfissionalService);

  profissionaisCount: any;

  ngOnInit(): void {
    this.profissionalService.list().subscribe(users => {
      if(users.data){
        this.profissionaisCount = users.records; // Calculate total users
      }

    });
  }

  cadastrarConcurso() {
    const ref = this.dialogService.open(CadastrarVagasComponent, {
      showHeader: false,
      width: '50%',
      modal: true,
    });

    ref.onClose.subscribe((data) => {
      if (data) {
        console.log('Form submitted:', data);
      }
    });
  }

}
